module.exports = __webpack_public_path__ + "static/media/teygja_bakvodvar_nidurtog_small.14320bae.png";